export const NOTIFICATION_MESSAGES = {
  syncError: { message: 'Sync failed' },
} as const;

export const PREVIEW_MODAL_MESSAGES = {
  filteringInfo: {
    message: 'Rollout target filtering',
    description:
      'Targets using Grab-specific facets (pax, dax, mex, meu, mem) will be excluded.',
  },
  pendingReview: {
    message: 'Existing pending review',
    description:
      'There is already a pending review for this variable. Syncing will cancel the existing pending review and create a new one.',
  },
  variableNotLinked: {
    message: 'Variable not linked',
    description:
      'The variable exists but is not linked to this Grab variable. Syncing will overwrite metadata and create the link.',
  },
} as const;

export const TOOLTIP_MESSAGES = {
  syncButtonDisabled: 'Save or discard your rollout changes before syncing',
  syncButtonEnabled: 'Move rollout targets to twin variable',
} as const;

export const METADATA_LOCK_MESSAGES = {
  title: 'Metadata Editing Disabled',
  description:
    'This variable is synced from Grab. Metadata can only be edited on the Grab portal.',
} as const;
